"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var sumReducer = function (accumulated, next) { return accumulated + next; };
var minReducer = function (accumulated, next) { return (accumulated === undefined ? next : Math.min(accumulated, next)); };
var maxReducer = function (accumulated, next) { return (accumulated === undefined ? next : Math.max(accumulated, next)); };
var reducers = {
    max: maxReducer,
    min: minReducer,
    sum: sumReducer
};
var aggregateColumn = function (column, data) {
    var value;
    if (column.aggregate === 'avg') {
        value = data.map(function (d) { return d[column.property]; }).reduce(sumReducer);
        value /= data.length;
    }
    else {
        value = data.map(function (d) { return d[column.property]; }).reduce(reducers[column.aggregate], 0);
    }
    return value;
};
var findPrimary = function (nextProps, prevState, nextState) {
    var columns = nextProps.columns;
    var primaryProperty;
    columns.forEach(function (column) {
        // remember the first key property
        if (column.primary && !primaryProperty) {
            primaryProperty = column.property;
        }
    });
    if (!primaryProperty && columns.length > 0) {
        primaryProperty = columns[0].property;
    }
    return tslib_1.__assign(tslib_1.__assign({}, nextState), { primaryProperty: primaryProperty });
};
var filter = function (nextProps, prevState, nextState) {
    var columns = nextProps.columns, onSearch = nextProps.onSearch;
    var data = nextState.data, filters = nextState.filters;
    var nextFilters;
    var regexps;
    columns.forEach(function (column) {
        if (column.search) {
            if (!nextFilters) {
                nextFilters = {};
                regexps = {};
            }
            nextFilters[column.property] = filters ? filters[column.property] || '' : '';
            // don't do filtering if the caller has supplied onSearch
            if (nextFilters[column.property] && column.search && !onSearch) {
                regexps[column.property] = new RegExp(nextFilters[column.property], 'i');
            }
        }
    });
    var nextData = data;
    if (nextFilters) {
        nextData = data.filter(function (datum) { return !Object.keys(regexps).some(function (property) { return !regexps[property].test(datum[property]); }); });
    }
    return tslib_1.__assign(tslib_1.__assign({}, nextState), { filters: nextFilters, data: nextData });
};
var aggregate = function (nextProps, prevState, nextState) {
    var columns = nextProps.columns;
    var data = nextState.data;
    var aggregateValues = {};
    columns.forEach(function (column) {
        if (column.aggregate) {
            aggregateValues[column.property] = aggregateColumn(column, data);
        }
    });
    return tslib_1.__assign(tslib_1.__assign({}, nextState), { aggregateValues: aggregateValues });
};
var buildFooterValues = function (nextProps, prevState, nextState) {
    var columns = nextProps.columns;
    var aggregateValues = nextState.aggregateValues;
    var showFooter;
    var footerValues = {};
    columns.forEach(function (column) {
        if (column.footer) {
            showFooter = true;
            if (typeof column.footer === 'string') {
                footerValues[column.property] = column.footer;
            }
            else if (column.footer.aggregate) {
                footerValues[column.property] = aggregateValues[column.property];
            }
        }
    });
    return tslib_1.__assign(tslib_1.__assign({}, nextState), { footerValues: footerValues, showFooter: showFooter });
};
var sortData = function (nextProps, prevState, nextState) {
    var sort = prevState.sort;
    var data = nextState.data;
    var nextData = data;
    if (sort) {
        var property_1 = sort.property, ascending = sort.ascending;
        nextData = tslib_1.__spreadArrays(data);
        var before_1 = ascending ? 1 : -1;
        var after_1 = ascending ? -1 : 1;
        nextData.sort(function (d1, d2) {
            if (d1[property_1] > d2[property_1]) {
                return before_1;
            }
            if (d1[property_1] < d2[property_1]) {
                return after_1;
            }
            return 0;
        });
    }
    return tslib_1.__assign(tslib_1.__assign({}, nextState), { data: nextData });
};
var groupData = function (nextProps, prevState, nextState) {
    var columns = nextProps.columns, groupBy = nextProps.groupBy;
    var data = nextState.data;
    var groups;
    var groupState;
    if (groupBy) {
        groups = [];
        groupState = {};
        var groupMap_1 = {};
        data.forEach(function (datum) {
            var groupValue = datum[groupBy];
            if (!groupMap_1[groupValue]) {
                var group = { data: [], datum: {}, key: groupValue };
                group.datum[groupBy] = groupValue;
                groups.push(group);
                groupState[groupValue] = {
                    expanded: prevState.groupState && prevState.groupState[groupValue] ? prevState.groupState[groupValue].expanded : false
                };
                groupMap_1[groupValue] = group;
            }
            groupMap_1[groupValue].data.push(datum);
        });
        // calculate any aggregates
        columns.forEach(function (column) {
            if (column.aggregate) {
                groups.forEach(function (group) {
                    group.datum[column.property] = aggregateColumn(column, group.data); // eslint-disable-line
                });
            }
        });
    }
    return tslib_1.__assign(tslib_1.__assign({}, nextState), { groups: groups, groupState: groupState });
};
exports.buildState = function (nextProps, prevState) {
    var data = nextProps.data;
    var filters = prevState.filters, sort = prevState.sort, widths = prevState.widths;
    var nextState = {
        data: data,
        filters: filters,
        sort: sort,
        widths: widths
    };
    nextState = findPrimary(nextProps, prevState, nextState);
    nextState = filter(nextProps, prevState, nextState);
    nextState = aggregate(nextProps, prevState, nextState);
    nextState = buildFooterValues(nextProps, prevState, nextState);
    nextState = sortData(nextProps, prevState, nextState);
    nextState = groupData(nextProps, prevState, nextState);
    return nextState;
};
//# sourceMappingURL=buildState.js.map